import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "all", "none", "item", "text", "search", "dropdown", "divider" ]

  connect() {
    this.updateUI();
    this.initializeDropdownObserver();
    this.initializeDropdownListener();
  }

  updatePlaceholder() {
    const count = this.itemTargets.filter((item) => item.checked).length;
    this.searchTarget.placeholder = `${count} of ${this.itemTargets.length} selected`;
  }

  selectAll() {
    this.noneTarget.checked = !this.allTarget.checked;
    this.itemTargets.forEach((item) => item.checked = this.allTarget.checked);
    this.updatePlaceholder();
  }

  selectNone() {
    this.allTarget.checked = !this.noneTarget.checked;
    this.itemTargets.forEach((item) => item.checked = !this.noneTarget.checked);
    this.updatePlaceholder();
  }

  filter() {
    this.itemTargets.forEach((item) => item.parentElement.parentElement.parentElement.classList.remove("hidden"));

    if (this.searchTarget.value.length > 1) {
      this.allTarget.parentElement.parentElement.parentElement.classList.add("hidden");
      this.noneTarget.parentElement.parentElement.parentElement.classList.add("hidden");
      this.dividerTarget.classList.add("hidden");
      this.textTargets.
        filter((item) => !item.textContent.includes(this.searchTarget.value)).
        forEach((item) => item.parentElement.parentElement.parentElement.classList.add("hidden"));
    } else {
      this.allTarget.parentElement.parentElement.parentElement.classList.remove("hidden");
      this.noneTarget.parentElement.parentElement.parentElement.classList.remove("hidden");
      this.dividerTarget.classList.remove("hidden");
    }
  }

  updateUI() {
    if (this.itemTargets.every((item) => item.checked)) {
      this.allTarget.checked = true;
      this.noneTarget.checked = false;
    } else if (this.itemTargets.every((item) => !item.checked)) {
      this.allTarget.checked = false;
      this.noneTarget.checked = true;
    } else {
      this.allTarget.checked = false;
      this.noneTarget.checked = false;
    }
    this.updatePlaceholder();
  }

  // The dropdown component provided by bootstrap doesn't have any easy way to
  // provide a callback for any events. This function adds an observer on the
  // dropdown element and watches it's class attribute to determine if it gets
  // toggled.
  initializeDropdownObserver() {
    new MutationObserver(
      (mutationList) => {
        mutationList.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            this.searchTarget.value = '';
            this.filter();
          }
        });
      }
    ).observe(this.dropdownTarget, { attributes: true });
  }

  // The bootstrap dropdown is configured to close on an outside click. This
  // improves the UI so that you can click the search box and keep the dropdown
  // expanded.
  initializeDropdownListener() {
    this.element.addEventListener('hide.bs.dropdown', (event) => {
      if (this.searchTarget == document.activeElement) {
        event.preventDefault();
      }
    });
  }
}
